import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import GeneralForm from "./GeneralForm"; // Import the GeneralForm component
import SubscriptionTab from "./SubscriptionTab.js";
import ChangePasswordTab from "./ChangePasswordTab.js";

const Profile = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const breadcrumbLabels = ["General", "Subscription", "Change Password"];

  // Icons grouped by tab name
  const icons = {
    general: {
      active: "./assets/img/profile/general.svg",
      inactive: "./assets/img/profile/general-inactive.svg",
    },
    subscription: {
      active: "./assets/img/profile/subscription.svg",
      inactive: "./assets/img/profile/subscription-inactive.svg",
    },
    password: {
      active: "./assets/img/profile/change-password.svg",
      inactive: "./assets/img/profile/change-password-inactive.svg",
    },
  };

  // Sidebar toggle
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Render header based on login type
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    return loginType === "AAD" ? <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" /> : <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  // Render tab header with icons
  const renderTabHeader = (key, index, label) => (
    <span>
      <img src={activeIndex === index ? icons[key].active : icons[key].inactive} alt={`${label} icon`} style={{ verticalAlign: "middle", marginRight: "8px", width: "18px", height: "18px" }} />
      {label}
    </span>
  );

  return (
    <div id="wrapper profile-page">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd scf esg-dashboard">
          <div className="flex justify-content-between">
            <div className="steps__containt-hader">
              <h1 className="title">Profile</h1>
              <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/forms-apps">
                  Profile
                </Link>
                <Typography color="text.primary">{breadcrumbLabels[activeIndex]}</Typography>
              </Breadcrumbs>
            </div>
          </div>
          <div className="tabs">
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
              <TabPanel header={renderTabHeader("general", 0, "General")}>
                <GeneralForm />
              </TabPanel>
              <TabPanel header={renderTabHeader("subscription", 1, "Subscription")}>
                <SubscriptionTab />
              </TabPanel>
              <TabPanel header={renderTabHeader("password", 2, "Change Password")}>
                <ChangePasswordTab />
              </TabPanel>
            </TabView>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
